<template>
  <div
    id="type-container"
    :style="colorStyle"
  >
    <p id="type-name">
      {{ i18nTypeName }}
    </p>
  </div>
</template>

<script>
import { processTestSampleTypeTagColor } from '@/utils/va-order-test/index.js';

export default {
  props: {
    typeName: {
      type: String,
      default: ""
    },
  },
  computed: {
    colorStyle() {
      let colorObj = processTestSampleTypeTagColor(this.typeName);
      return colorObj;
    },
    i18nTypeName() {
      let i18nKey = `OrderPage['${this.typeName}']`;
      return this.$t(i18nKey) === i18nKey ? this.typeName : this.$t(i18nKey);
    }
  }
}
</script>

<style scoped>
#type-container {
  box-sizing: border-box;
  height: 19px;
  display: inline-block;
  border: 1px solid;
  border-radius: 8px;
  padding: 0 3.5px;
}
#type-name {
  height: 14px;
  line-height: 14px;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0.34px;
  margin: 2.5px 2.5px;
  text-align: center;
}
</style>
